export const POINT_DIAMETER = 40;
export const POINT_RADIUS = POINT_DIAMETER / 2;
